//
// Device util
// -----------

define(function(require, exports, module) {
    'use strict';

    // Proxy is needed because Playtech.API.device is available only after App.jsx is initialized
    module.exports = new Proxy({}, {
        get: (target, name) => {
            if (name === '__esModule') {
                // needed for AMD modules in Backbone imports
                return false;
            }

            return Playtech?.API?.device?.[name]; /* TotalCasino changes */
        }
    });
});
